import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router) {}
  
  async canActivate(): Promise<boolean> {
    const themeType = sessionStorage.getItem('store-theme')

    switch (themeType) {
      case 'grison-dairy':
      case 'woodview':
        
        this.router.navigate(['/shop']);
        return false;

      default:
      
        this.router.navigate(['/categories']);
        return false;
    }
  }
}
